import { post, remove } from '../../Services/http';

export const subscribeToInStockMonitor = async (articleNumber) => {
    const response = await post('/api/bft-in-stock-monitor', { articleNumber });
    return response;
};

export const unsubscribeFromInStockMonitor = async (articleNumber) => {
    const response = await remove('/api/bft-in-stock-monitor', { articleNumber });
    return response;
};
